import MenuView from "./routes/menu/menu";
import ErrorView from "./routes/error/Error";
import ArchivedView from "./routes/archived/Archived";
import GameView from "./routes/game/game";
import NewGame from "./routes/newgame/NewGame";
import WalletOp from "./routes/walletop/WalletOp";
import JoinView from "./routes/join/JoinView";
import FindView from "./routes/findgame/FindGame";
import Welcome from "./routes/welcome/Welcome";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import React from "react";
import { THEME, TonConnectUIProvider } from "@tonconnect/ui-react";
import "./App.css";

const App = () => {
  return (
    <TonConnectUIProvider
      manifestUrl="https://raw.githubusercontent.com/danichmur/ton_connect/refs/heads/main/pytonconnect-manifest.json"
      uiPreferences={{ theme: THEME.DARK }}
      walletsListConfiguration={{
        includeWallets: [
          {
            appName: "tonwallet",
            name: "TON Wallet",
            imageUrl: "https://wallet.ton.org/assets/ui/qr-logo.png",
            aboutUrl:
              "https://chrome.google.com/webstore/detail/ton-wallet/nphplpgoakhhjchkkhmiggakijnkhfnd",
            universalLink: "https://wallet.ton.org/ton-connect",
            jsBridgeKey: "tonwallet",
            bridgeUrl: "https://bridge.tonapi.io/bridge",
            platforms: ["chrome", "android"],
          },
          {
            appName: "nicegramWallet",
            name: "Nicegram Wallet",
            imageUrl: "https://static.nicegram.app/icon.png",
            aboutUrl: "https://nicegram.app",
            universalLink: "https://nicegram.app/tc",
            deepLink: "nicegram-tc://",
            jsBridgeKey: "nicegramWallet",
            bridgeUrl: "https://bridge.tonapi.io/bridge",
            platforms: ["ios", "android"],
          },
          {
            appName: "fintopio-tg",
            name: "Fintopio Telegram",
            imageUrl: "https://fintopio.com/tonconnect-icon.png",
            aboutUrl: "https://fintopio.com",
            universalLink: "https://t.me/fintopio?attach=wallet",
            bridgeUrl: "https://wallet-bridge.fintopio.com/bridge",
            platforms: ["ios", "android", "macos", "windows", "linux"],
          },
          {
            appName: "tokenpocket",
            name: "TokenPocket",
            imageUrl: "https://hk.tpstatic.net/logo/tokenpocket.png",
            aboutUrl: "https://tokenpocket.pro",
            jsBridgeKey: "tokenpocket",
            platforms: ["ios", "android"],
          },
          {
            appName: "dewallet",
            name: "DeWallet",
            imageUrl:
              "https://raw.githubusercontent.com/delab-team/manifests-images/main/WalletAvatar.png",
            aboutUrl: "https://delabwallet.com",
            universalLink: "https://t.me/dewallet?attach=wallet",
            bridgeUrl: "https://bridge.dewallet.pro/bridge",
            platforms: ["ios", "android", "macos", "windows", "linux"],
          },
          {
            appName: "BitgetWeb3",
            name: "BitgetWeb3",
            imageUrl: "https://img.bitgetimg.com/image/third/1723701408284.png",
            aboutUrl: "https://www.bitget.com",
            universalLink: "https://t.me/BitgetOfficialBot?attach=wallet",
            bridgeUrl: "https://ton-connect-bridge.bgwapi.io/bridge",
            platforms: ["ios", "android", "windows", "macos", "linux"],
          },
          {
            appName: "cdcTonWallet",
            name: "Crypto.com DeFi Wallet",
            imageUrl: "https://apro-ncw-api-file.crypto.com/wallet/logo",
            aboutUrl: "https://crypto.com/defi-wallet",
            universalLink: "https://wallet.crypto.com/deeplink/ton-connect",
            deepLink: "dfw://",
            jsBridgeKey: "cdcTonWallet",
            bridgeUrl: "https://wallet.crypto.com/sse/tonbridge",
            platforms: ["ios", "android", "chrome"],
          },
          {
            appName: "tobi",
            name: "Tobi",
            imageUrl: "https://app.tobiwallet.app/icons/logo.png",
            aboutUrl: "https://tobi.fun",
            universalLink: "https://t.me/TobiWalletBot?attach=wallet",
            bridgeUrl: "https://bridge.tonapi.io/bridge",
            platforms: ["ios", "android", "macos", "windows", "linux"],
          },
          {
            appName: "trustwalletTon",
            name: "Trust",
            imageUrl: "https://assets-cdn.trustwallet.com/dapps/trust.logo.png",
            aboutUrl: "https://trustwallet.com/about-us",
            bridgeUrl: "https://tonconnect.trustwallet.com/",
            jsBridgeKey: "trustwalletTon",
            platforms: ["chrome", "ios", "android"],
          },
        ],
      }}
      actionsConfiguration={{
        twaReturnUrl: "https://t.me/secretdice_bot",
      }}
    >
      <Main />
    </TonConnectUIProvider>
  );
};

const Main = () => {
  return (
    <div className="body">
      <Router>
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/menu/" element={<MenuView />} />
          <Route path="/walletop/" element={<WalletOp />} />
          <Route path="/game/:id/" element={<GameView />} />
          <Route path="/newgame/" element={<NewGame />} />
          <Route path="/join/:id/" element={<JoinView />} />
          <Route path="/join/" element={<JoinView />} />
          <Route path="/find" element={<FindView />} />
          <Route path="/archived/:id" element={<ArchivedView />} />
          <Route path="/error" element={<ErrorView />} />
        </Routes>
      </Router>
    </div>
  );
};
export default App;

// const fn = async () => {
//   console.log("call fn");
//   try {
//     const status = await requestWriteAccess();
//     console.log("status", status);
//   } catch (e) {}
// };
//   // if (requestWriteAccess.isSupported()) {
//   //   fn();
//   // } else {
//   //   console.log("not supported");
//   // }
// const [balance, setBalance] = useState(null);

// const updateBalance = (value) => {
//   if (value) {
//     setBalance(value);
//   } else {
//     fetchBalance(setBalance);
//     console.log("updateBalance");
//   }
// };

// useEffect(() => {
//   updateBalance();
// }, []);
